import type { VoidFunctionComponent } from 'react';

import { FormGroup } from '../../generic/Forms';
import { useAuthContext } from '../context/AuthContext';

import EmailMfaVerification from './EmailMfaVerification';
import TotpMfaVerification from './TotpMfaVerification';

/**
 * MFA verification form that displays the appropriate MFA method.
 * Handles both Email and TOTP MFA methods.
 */
const MfaVerification: VoidFunctionComponent = () => {
  const { mfaMethod } = useAuthContext();

  return (
    <FormGroup>
      {mfaMethod === 'email' ? (
        <EmailMfaVerification />
      ) : (
        <TotpMfaVerification />
      )}
    </FormGroup>
  );
};

export default MfaVerification;
